import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import './FAQ.css';

function FAQ() {
    const [isOpen, setIsOpen] = useState({});

    const toggleAccordion = (id) => {
        const isCurrentlyOpen = isOpen[id];

        const updatedOpenState = {};
        Object.keys(isOpen).forEach((itemId) => {
            if (itemId !== id) {
                updatedOpenState[itemId] = false;
            }
        });

        setIsOpen({
            ...updatedOpenState,
            [id]: !isCurrentlyOpen 
        });
    };

    return (
        <>
        <div className="d-flex justify-content-center align-items-center mt-5">
            <img className='img-fluid' src="../images/COVERAGE.png" alt="" />
        </div>
        <div className='d-flex justify-content-center align-items-center'>
            <img className='img-fluid' src="../images/Frame 1321316057.png" alt="" />
        </div>

        <section style={{ fontFamily: 'D-DIN Exp, sans-serif' }} className="faq-section section">
            <h1 className='text-center py-5'>Frequently Asked Questions</h1>

            <div className="container">
                {faqData.map((faqItem, index) => (
                    <div
                        className={`collapse-container ${isOpen[faqItem.id] ? 'opened' : ''}`}
                        key={index}
                    >
                        <p
                            className="custom-link d-flex align-items-center mt-3 gap-2 ms-2"
                            onClick={() => toggleAccordion(faqItem.id)}
                        >
                            <FontAwesomeIcon icon={isOpen[faqItem.id] ? faMinus : faPlus} />
                            <span>{faqItem.question}</span>
                        </p>

                        <div
                            id={faqItem.id}
                            className={`ms-4 collapse custom-collapse ${isOpen[faqItem.id] ? 'show' : ''}`}
                        >
                            <p>{faqItem.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
        </>
        
    );
}

const faqData = [
    {
        id: 'faq1',
        question: 'How do I sign up with Connekt services?',
        answer: `You can sign up for an account by sending 
        an email to (info@connekt.me) or call 02014121234.`
    },
    {
        id: 'faq2',
        question: 'Do you offer discount?',
        answer: 'Yes, we do. T & C apply'
    },
    {
        id: 'faq3',
        question: 'Does Connekt have a portable modem?',
        answer: `No, Connekt Broadband is focused on providing 
        stable and secure internet services to homes and offices 
        through radio and fiber technology.`
    },
    {
        id: 'faq4',
        question: 'What is my Connekt ID number?',
        answer: `Your Connekt ID number is a unique
         1-5 digit number that distinguishes you on 
         the Connekt Broadband Platform. This ID is 
         usually generated and shared with you at 
         the point of service integration.`
    },
    {
        id: 'faq5',
        question: 'How long will it take to complete an installation?',
        answer: 'Installation takes about 4 hours to be completed'
    },
    {
        id: 'faq6',
        question: 'Do I make payment for a survey to be carried out?',
        answer: 'No, surveys are carried out free of charge'
    },
    {
        id: 'faq7',
        question: 'Can I use Connekt internet service for my large office?',
        answer: ' Yes, we have plans that can accommodate all internet requirements.'
    }
];

export default FAQ;
